import React, { memo } from "react";

import {
  Button,
  HStack,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  Text,
  VStack,
} from "@chakra-ui/react";
import { useAuth } from "modules/providers/auth-provider";
import { useUsers } from "modules/providers/users-provider";
import { getUserFullName } from "modules/utils/Functions";
import { LockIcon } from "modules/icons";
import colors from "app/colors";
import ModalTitle from "./modal-title";
import { useOverlay } from "modules/providers/overlay-provider";

interface IProps {
  lockedUserId: string;
}

const LockedConversationModal = ({ lockedUserId }: IProps) => {
  const { closeModal } = useOverlay();
  const { me } = useAuth();
  const { usersById } = useUsers();

  const isMe = lockedUserId === me?.id;
  const user = usersById[lockedUserId];
  const name = user ? getUserFullName(user) : "<unknown>";

  return (
    <Modal isOpen onClose={closeModal} size="xs" isCentered>
      <ModalOverlay />
      <ModalContent borderRadius={16}>
        <ModalBody p={6}>
          <VStack textAlign="center" spacing={4}>
            <ModalTitle
              text="Private Threads?"
              icon={<LockIcon boxSize={16} />}
            />
            {isMe ? (
              <Text fontSize={13} color={colors.gray50} fontWeight={500}>
                You have set this thread to “Private” to prevent anyone with
                access to it from adding users and groups.
              </Text>
            ) : (
              <Text fontSize={13} color={colors.gray50} fontWeight={500}>
                <Text as="span" fontWeight={700}>
                  {name}
                </Text>
                , has set this thread to “Private” to prevent anyone with access
                to it from adding users and groups.
              </Text>
            )}
            <Text fontSize={13} color={colors.gray50} fontWeight={500}>
              Anyone in the thread can remove the setting.
            </Text>
            <HStack>
              <Button height={8} px={10} onClick={closeModal}>
                Got it!
              </Button>
            </HStack>
          </VStack>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default memo(LockedConversationModal);
